
import { Component, Prop, Vue } from "vue-property-decorator";

import Tooltip from "@/components/common/Tooltip.vue";
import WarningIcon from "@/components/icons/WarningIcon.vue";

import Variants from "@/entities/TooltipVariants";

@Component({
  components: {
    Tooltip,
    WarningIcon,
  },
})
export default class ActivityHoursUnconfirmedAlert extends Vue {
  @Prop({ type: String, required: true }) readonly title!: string;
  @Prop({ type: String, default: "w-6 h-6" }) readonly iconClasses!: string;

  get tooltipVariant(): string {
    return Variants.DARK;
  }
}
